export const DEFAULT_NOTES = {
  scr: 'Checked all PAS Devices in the SCR, All working Normally',
  microphoneStationGroup: 'Checked Mic Stations at gates **** and all related announcements, all working normally.',
  systemFaultLog: 'Checked CTP-* related schedule and logs, checked system and subcontrollers time and synchronysations.(**:**)',
  others: ''
};

const getTodayInputDate = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const createDefaultRow = {
  scr: () => ({ time: '', number: '', tag: '', status: 'OK', notes: DEFAULT_NOTES.scr }),
  microphoneStationGroup: () => ({
    time: '',
    area: '',
    status: 'OK',
    notes: DEFAULT_NOTES.microphoneStationGroup
  }),
  correctiveMaintenance: () => ({ time: '', cmNo: '', status: '', notes: '' }),
  systemFaultLog: () => ({ time: '', logType: '', status: '', notes: DEFAULT_NOTES.systemFaultLog }),
  ppm: () => ({ time: '', ppmNo: '', status: '', notes: '' }),
  others: () => ({ time: '', area: '', notes: DEFAULT_NOTES.others })
};

export const buildInitialFormData = () => ({
  shift: '',
  shiftTime: '',
  inCharge: '',
  date: getTodayInputDate(),
  secondDate: '',
  scrArea: '',
  scr: [createDefaultRow.scr()],
  microphoneStationGroup: [createDefaultRow.microphoneStationGroup()],
  correctiveMaintenance: [createDefaultRow.correctiveMaintenance()],
  systemFaultLog: [createDefaultRow.systemFaultLog()],
  ppm: [createDefaultRow.ppm()],
  others: [createDefaultRow.others()]
});

export const SECTION_LABELS = {
  scr: 'SCR',
  microphoneStationGroup: 'Microphone Station Group',
  correctiveMaintenance: 'Corrective Maintenance',
  systemFaultLog: 'System Log',
  ppm: 'PPM',
  others: 'Others'
};
